import { render, staticRenderFns } from "./ButtonApplePay.vue?vue&type=template&id=4c96f396&scoped=true&"
import script from "./ButtonApplePay.vue?vue&type=script&lang=js&"
export * from "./ButtonApplePay.vue?vue&type=script&lang=js&"
import style0 from "./ButtonApplePay.vue?vue&type=style&index=0&id=4c96f396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96f396",
  null
  
)

export default component.exports